const appStore = {
  employee_data: {
    file: null,
    tabledata: null,
    click_dragger: false,
    pathId: '',
    uploaded_data: null,
    entities: []
  },
  showSpendingAccount: false,
  company_id: ''
}

export default appStore
